var _path, _path2, _path3, _g, _path4, _path5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagBr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "flag-br_svg__a",
  width: 32,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#flag-br_svg__a)"
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#093",
  fillRule: "evenodd",
  d: "M0 0v24h32V0z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "flag-br_svg__b",
  width: 32,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 0v24h32V0z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#flag-br_svg__b)"
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  filter: "url(#flag-br_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFD221",
  d: "m15.927 3.704 12.202 8.504L15.76 20.17 3.809 12.043z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#flag-br_svg__d)",
  d: "m15.927 3.704 12.202 8.504L15.76 20.17 3.809 12.043z"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#2E42A5",
  fillRule: "evenodd",
  d: "M16 17.2a5 5 0 1 0 0-10 5 5 0 0 0 0 10",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "flag-br_svg__e",
  width: 10,
  height: 11,
  x: 11,
  y: 7,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M16 17.2a5 5 0 1 0 0-10 5 5 0 0 0 0 10",
  clipRule: "evenodd"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#flag-br_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7FCFF",
  fillRule: "evenodd",
  d: "m14.38 14.57-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM16.38 14.57l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM16.38 15.77l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM15.38 11.57l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM15.38 13.57l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM13.98 12.57l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.043.248zM12.58 13.37l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM17.18 9.97l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7FCFF",
  d: "m9.925 10.997.15-1.994c4.798.362 8.585 1.94 11.313 4.745l-1.434 1.395c-2.364-2.433-5.692-3.819-10.03-4.146"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#093",
  d: "m12.29 10.603.051-.498c3.093.32 5.746 1.505 7.95 3.552l-.34.366q-3.184-2.956-7.661-3.42"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "flag-br_svg__d",
  x1: 32,
  x2: 32,
  y1: 24,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC600"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDE42"
})), /*#__PURE__*/React.createElement("filter", {
  id: "flag-br_svg__c",
  width: 24.32,
  height: 16.467,
  x: 3.809,
  y: 3.704,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0313726 0 0 0 0 0.368627 0 0 0 0 0 0 0 0 0.28 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1442_9508"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1442_9508",
  result: "shape"
})))));
export default SvgFlagBr;